import appsRouterPaths from './appsRouterPaths';

export default appsRouterPaths;
